import React from "react";
import { Route, Redirect } from "react-router-dom";

export default ({ component: C, props: cProps, ...rest }) =>
  <DebugRoute
    {...rest}
    render={props =>
      cProps.isAuthenticated
        ? <C {...props} {...cProps} />
        : <Redirect
            to={`${process.env.PUBLIC_URL}/login?redirect=${props.location.pathname}${props.location.search}`}
          />}
  />;

  //{`${process.env.PUBLIC_URL}/`}

  class DebugRoute extends Route {
    constructor(props){
      super(props);
      console.log(`${process.env.PUBLIC_URL}/login?redirect=${process.env.PUBLIC_URL}${props.location.pathname}${props.location.search}`);
    }
  }
  